import { render, staticRenderFns } from "./CouponSetting.vue?vue&type=template&id=07250d22&"
import script from "./CouponSetting.vue?vue&type=script&lang=js&"
export * from "./CouponSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07250d22')) {
      api.createRecord('07250d22', component.options)
    } else {
      api.reload('07250d22', component.options)
    }
    module.hot.accept("./CouponSetting.vue?vue&type=template&id=07250d22&", function () {
      api.rerender('07250d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/CouponSetting.vue"
export default component.exports